import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTebGelirAramaComponent} from './ctl-teb-gelir-arama/ctl-teb-gelir-arama.component';
import {TebGelirService} from './ctl-teb-gelir.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-teb-gelir',
  templateUrl: './ctl-teb-gelir.component.html',
  styleUrls: ['./ctl-teb-gelir.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTebGelirAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
  ]
})
export class CtlTebGelirComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "TebGelir";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code: string;
  @Input() period!: number;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();
  @Input() notFoundMessage: string='Bulunamadı!';

  constructor(private service: TebGelirService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)
      }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Teb Gelir)"
      this.showAction = false
    }
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)
  }
  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if (this.isFirst) this.isFirst = false;

        }
      });
  }


  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: string, isSetData?: boolean) {

    this.data = this.service.getData(code,this.control, this.period, this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].EkoGelirKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError(this.notFoundMessage);
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst = true
      this.data = result.data;
      this.title = result.data.Ad;
      this.code = result.data.EkoGelirKod;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
